<div class="toast cookie-popup" [ngClass]="{ 'show': cookiePolicyService.showCookiePopup}">
  <div class="toast-header">
    <strong class="me-auto">Allow Cookies?</strong>
    <small></small>
    <button type="button" class="btn-close ms-2 mb-1" aria-label="Close" (click)="cookiePolicyService.close()"></button>
  </div>
  <div class="toast-body">
    We use cookies to ensure you get the best experience on our website.<br />
    <a routerLink="/cookie-policy">Learn more about our cookies</a>
    <button type="button" class="btn btn-primary w-100" (click)="cookiePolicyService.accept()">Allow
      Cookies</button>

  </div>
</div>